<template>
  <EditableArea
    v-if="header && Object.keys(header).length"
    :content="header"
  />
  <KikSkeletonHeader v-else />
</template>

<script lang="ts" setup>
import { EditableArea } from '@magnolia/vue-editor';
import { usePageLoader } from '~/composables/custom/usePageLoader/usePageLoader';
import { useSSR } from '~/composables/useSSR/useSSR';

const { getHeader, header } = usePageLoader('header-inherited');
const { onSSR } = useSSR();

onSSR(async () => {
  if (header.value) {
    return;
  }

  await getHeader();
});
</script>
